// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3fvR1","title":"AfterFrontImage_title__AXMyv"};